const serviceWorker = require('../../serviceWorker.js');
const env = require("../../config.js").default;
const db = require("./indexDB.js");
const common = require('../common/common.jsx');

/*
  Ticket Common library. Functions are divided in sections:

  1. filterTable
  2. utility

*/
/* ================================================================================================================================================== */
/* FILTER TABLE */
export function get_filters_values(key, section, specific = null){
    var a = new Promise((resolve, reject) => {
         db.getUXPageSectionValue(key, section).then((data) => {
            if(data === undefined){
                var defaultData = {}
                defaultData['stati'] = ['pending', 'incomplete', 'published'];
                resolve(defaultData)
            }else{
                var defaultData = null
                resolve(defaultData)
            }
        })
    })
    return a
}

export async function get_filters_values_wrap(key, section) {
    var data = await get_filters_values(key, section)
    return data
}

/* ================================================================================================================================================== */
/* UTILITY */

export function addDot(value, myClass) {
    const $ = window.$;
    var searchContainer = myClass;
    var orangeDot = $('.orange-dot', searchContainer);
    if (value) {
        if (orangeDot.length === 0) {
            searchContainer.prepend('<span class="orange-dot"></span>');
        }
    } else {
        orangeDot.remove();
    }
}

export function codifica_stati(stato) {
    var stato_cod = null;

    if (stato === 'incomplete') {
        stato_cod = '11';
    } else if (stato === 'published') {
        stato_cod = '70';
    } else if (stato === 'pending') {
        stato_cod = '05';
    } else {
        stato_cod = '90';
    }
    return stato_cod;
}